import React from 'react';
import TempleCard from './TempleCard';
import './TempleGrid.css';

function groupByState(temples) {
  const groups = [];
  const idx = {};
  temples.forEach(t => {
    const key = t._stateName || '';
    if (!(key in idx)) { idx[key] = groups.length; groups.push({ state: t._stateName, stateHi: t._stateNameHi, temples: [] }); }
    groups[idx[key]].temples.push(t);
  });
  return groups;
}

export default function TempleGrid({ temples, loading, error, lang, activeState, circuitMode }) {
  const L = (en, hi) => lang === 'en' ? en : hi;

  if (!activeState && !circuitMode) return (
    <div className="grid-empty">
      <div className="grid-empty-icon">🗺️</div>
      <h2>{L('Select a state to begin','राज्य चुनने के लिए क्लिक करें')}</h2>
      <p>{L('Choose a state from the left panel to explore its sacred sites.','बाएं पैनल से एक राज्य चुनें।')}</p>
    </div>
  );
  if (loading) return (
    <div className="grid-loading">
      <div className="spinner" />
      <p>{L('Loading sacred sites…','पवित्र स्थल लोड हो रहे हैं…')}</p>
    </div>
  );
  if (error) return <div className="grid-error"><p>⚠️ {error}</p></div>;
  if (!temples || temples.length === 0) return (
    <div className="grid-empty">
      <div className="grid-empty-icon">🔍</div>
      <h2>{L('No sites found','कोई स्थल नहीं मिला')}</h2>
      <p>{L('Try adjusting your filters or search.','फ़िल्टर या खोज बदलकर देखें।')}</p>
    </div>
  );

  if (circuitMode) {
    const groups = groupByState(temples);
    const multiState = groups.length > 1;
    return (
      <div className="circuit-grid-wrap">
        {groups.map(group => (
          <div key={group.state || 'main'} className="circuit-state-group">
            {multiState && (
              <h3 className="circuit-state-header">
                {lang === 'en' ? group.state : (group.stateHi || group.state)}
              </h3>
            )}
            <div className="temple-grid">
              {group.temples.map((t, i) => (
                <div key={t.id} className="fade-in" style={{ animationDelay: `${Math.min(i * 30, 300)}ms` }}>
                  <TempleCard temple={t} lang={lang} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="temple-grid">
      {temples.map((t, i) => (
        <div key={t.id} className="fade-in" style={{ animationDelay: `${Math.min(i * 30, 300)}ms` }}>
          <TempleCard temple={t} lang={lang} />
        </div>
      ))}
    </div>
  );
}
